import { c as _c } from "react/compiler-runtime";
import { useTheme } from "@mui/material";
import { OrbitControls } from "@react-three/drei";
import { Canvas } from "@react-three/fiber";
import { type OrbitControls as ThreeOrbitControls } from "three-stdlib";
import { PythonLogoModel } from "#/3d-models/PythonLogoModel";
type PythonLogoViewProps = {
  controlsRef: React.RefObject<ThreeOrbitControls | null>;
};
export const PythonLogoView: React.FC<PythonLogoViewProps> = t0 => {
  const $ = _c(16);
  const {
    controlsRef
  } = t0;
  const theme = useTheme();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <ambientLight intensity={2.25} />;
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = [3.592, 5.939, 3.134];
    t3 = [-1.839, 0.602, 1.932];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  let t4;
  if ($[3] !== theme.palette.primary.main) {
    t4 = <pointLight intensity={2} decay={2} color={theme.palette.primary.main} position={t2} rotation={t3} />;
    $[3] = theme.palette.primary.main;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = [-6.44, -5.881, 2.343];
    t6 = [-1.839, 0.602, 1.932];
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  if ($[7] !== theme.palette.primary.light) {
    t7 = <pointLight intensity={1} decay={2} color={theme.palette.primary.light} position={t5} rotation={t6} />;
    $[7] = theme.palette.primary.light;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <PythonLogoModel />;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== controlsRef) {
    t9 = <OrbitControls ref={controlsRef} minAzimuthAngle={Math.PI / -2.2} maxAzimuthAngle={Math.PI / 2.2} minPolarAngle={Math.PI / 10} maxPolarAngle={Math.PI / 1.1} minDistance={6} maxDistance={15} enableRotate={true} enableZoom={false} enablePan={false} dampingFactor={0.005} />;
    $[10] = controlsRef;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== t4 || $[13] !== t7 || $[14] !== t9) {
    t10 = <Canvas>{t1}{t4}{t7}{t8}{t9}</Canvas>;
    $[12] = t4;
    $[13] = t7;
    $[14] = t9;
    $[15] = t10;
  } else {
    t10 = $[15];
  }
  return t10;
};